<template>
    <div class='ProductDetails col-12'>
        <div class='ShortView row'>
            <div class='ImageSection col-4'>
                <div class='ProductImage row'>
                    <ImageCarousel
                        :images='productImages'
                        store='ItemInfo'
                        name='productImages'
                    />
                </div>
                <ProductPricing
                    :price='productPrice'
                    :margin='productMargin'
                    :discount='productDiscount'
                    store='ItemInfo'
                />
            </div>
            <div class='ProductSection col-8'>
                <div class='ProductNameRow row'>
                    <h3 class='ProductName col-9'>{{name.name}}</h3
                    ><button 
                        class='btn btn-primary id-btn col-2'
                        v-if='editable'
                        >{{id}}
                    </button>    
                    <button 
                        class='btn btn-primary edit-btn col-1'
                        v-if='editable'
                        >
                        <EditIcon />
                    </button>
                </div>
                <div class='ProductSkuRow row'>
                    <span class='ProductSku col-3'>{{sku}}</span>
                    <button 
                        class='btn btn-primary id-btn col-1'
                        v-if='editable'
                        >{{id}}
                    </button>
                </div>
                <div class='PrimaryAttributes row' :key='uaidx'> 
                    <div class='col-12'>
                        <div class='row'>
                            <div class='col-12'>
                                <TextBox
                                    label="Additional Description"
                                    store='ItemInfo'
                                    name='additionalDescription'
                                    placeholder=''
                                />
                            </div>
                        </div>
                        <div class='row'>
                            <div class='col-6'>
                                <TextBox
                                    label="Category"
                                    store='ItemInfo'
                                    name='category'
                                    placeholder=''
                                />
                            </div>
                            <div class='col-6'>
                                <TextBox
                                    label="Subcategory"
                                    store='ItemInfo'
                                    name='subcategory'
                                    placeholder=''
                                />
                            </div>
                        </div>
                         <div class='row'>
                            <div class='col-6'>
                                <TextBox
                                    label="Brand"
                                    store='ItemInfo'
                                    name='brand'
                                    placeholder=''
                                />
                            </div>
                            <div class='col-6'>
                                <TextBox
                                    label="Style"
                                    store='ItemInfo'
                                    name='style'
                                    placeholder=''
                                />
                            </div>
                        </div>
                         <div class='row'>
                            <div class='col-6'>
                                <TextBox
                                    label="Material"
                                    store='ItemInfo'
                                    name='material'
                                    placeholder=''
                                />
                            </div>
                            <div class='col-6'>
                                <TextBox
                                    label="Color"
                                    store='ItemInfo'
                                    name='color'
                                    placeholder=''
                                />
                            </div>
                        </div>
                         <div class='row'>
                            <div class='col-6 SelectBox' >
                            <Select
                                label='Condition'
                                store='ItemInfo'
                                name='condition'
                                :options='conditionOptions'
                            />
                            </div>
                            <div class='col-6'>
                                <TextBox
                                    label="Serial"
                                    store='ItemInfo'
                                    name='serial'
                                    placeholder=''
                                />
                            </div>
                        </div>
                        <div class='row'>
                            <div class='col-6'>
                                <TextBox
                                    label="Origin"
                                    store='ItemInfo'
                                    name='origin'
                                    placeholder=''
                                />
                            </div>
                            <div class='col-6'>
                                <TextBox
                                    label="Item ID"
                                    store='ItemInfo'
                                    name='id'
                                    placeholder=''
                                />
                            </div>
                        </div>
                        <div class='row'>
                            <div class='col-6 SelectBox'>
                                <Select
                                    label="Core?"
                                    store='ItemInfo'
                                    name='core'
                                    :options='coreOptions'
                                />
                            </div>
                            <div class='col-6 SelectBox'>
                                <Select
                                    label="Iconic?"
                                    store='ItemInfo'
                                    name='iconic'
                                    :options='iconicOptions'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class='AdditionalView row' :key='uaidx'>
            <div class='SalesSection col-12'>
                <div class='SalesFields row'>
                    <div class='col-4'>
                        <CurrencyInput
                            label="Cost"
                            store='ItemInfo'
                            name='cost'
                            placeholder=''
                        />
                    </div>
                    <div class='col-4'>
                        <TextBox
                            label="Allocation"
                            store='ItemInfo'
                            name='allocation'
                            placeholder=''
                        />
                    </div>
                    <div class='col-4'>
                        <TextBox
                            label="VendorID"
                            store='ItemInfo'
                            name='vendorItemId'
                            placeholder=''
                        />
                    </div>
                </div>
                <div class='SalesFields row'>
                    <div class='col-4'>
                        <CurrencyInput
                            label="Retail"
                            store='ItemInfo'
                            name='retail'
                            placeholder=''
                        />
                    </div>
                    <div class='col-4'>
                        <TextBox
                            label="Shelf Name"
                            store='ItemInfo'
                            name='shelfName'
                            placeholder=''
                        />
                    </div>
                    <div class='col-4'>
                        <TextBox
                            label="Vendor Name"
                            store='ItemInfo'
                            name='vendor'
                            placeholder=''
                        />
                    </div>
                </div>
                 <div class='SalesFields row'>
                    <div class='col-4'>
                        <TextBox
                            label="Margin"
                            store='ItemInfo'
                            name='margin'
                            placeholder=''
                        />
                    </div>
                    <div class='col-4'>
                        <TextBox
                            label="Item Age"
                            store='ItemInfo'
                            name='itemAge'
                            placeholder=''
                        />
                    </div>
                    <div class='col-4'>
                        <TextBox
                            label="Vendor Sku"
                            store='ItemInfo'
                            name='vendorSku'
                            placeholder=''
                        />
                    </div>
                </div>
                <div class='SalesFields row'>
                    <div class='col-4'>
                        <CurrencyInput
                            label="MSRP"
                            store='ItemInfo'
                            name='msrp'
                            placeholder=''
                        />
                    </div>
                    <div class='col-4'>
                        <TextBox
                            label="Retail Sales Velocity"
                            store='ItemInfo'
                            name='retailSalesVelocity'
                            placeholder=''
                        />
                    </div>
                    <div class='col-4'>
                        <CurrencyInput
                            label="Vendor Cost"
                            store='ItemInfo'
                            name='vendorCost'
                            placeholder=''
                        />
                    </div>
                </div>
                <div class='SalesFields row'>
                    <div class='col-8 spacer'>
                        &nbsp;
                    </div>
                    <div class='col-4'>
                        <CurrencyInput
                            label="MSRP Discount"
                            store='ItemInfo'
                            name='msrpDiscount'
                            placeholder=''
                        />
                    </div>
                </div>
                <div class='SalesFields row'>
                    <div class='col-8 spacer'>
                        &nbsp;
                    </div>
                    <div class='col-4'>
                        <TextBox
                            label="Buyer"
                            store='ItemInfo'
                            name='itemBuyer'
                            placeholder=''
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DisplayFormInput from '../../core/form/DisplayFormInput';
import ImageCarousel from '../../widget/ImageCarousel/ImageCarousel';
import ProductPricing from './ProductPricing';
import EditIcon from '../../icons/EditIcon';
import TextBox from '../../core/form/TextBox';
import Select from '../../core/form/Select';
import CurrencyInput from '../../core/form/CurrencyInput';

export default {
    name: 'ProductDetails',
    props: [ 'name', 'sku', 'id', 'images', 'attributes', 'pricing'],
    components:{
        DisplayFormInput,
        ImageCarousel,
        ProductPricing,
        EditIcon,
        TextBox,
        Select,
        CurrencyInput
    },
    data(){
        return{
            productImages: this.$props.images,
            editable: false,
            uaidx: 0,
            cutOff: 12,
            TextBoxClass: 'TextBox',
            conditionOptions: [],
            coreOptions: [],
            iconicOptions: [],
        }
    },
    computed:{
        productPrice(){
            return this.$store.getters['ItemInfo/currentPrice']
        },
        productMargin(){
            return this.$store.getters['ItemInfo/adjustedMargin']
        },
        productDiscount(){
            return this.$store.getters['ItemInfo/addedDiscount']
        }
    },
    created(){
        this.getConditionOptions();
        this.getCoreOptions();
        this.getIconicOptions();
    },
    methods:{
        getConditionOptions() {
            this.$api.get('/api/faker', {}).then(response => {
                this.conditionOptions = [
                    {value: 1, label: 'Condition A'},
                    {value: 2, label: 'Condition B'},
                    {value: 3, label: 'Condition C'},
                    {value: 4, label: 'Condition D'}
                ]
            });
        },
        getCoreOptions() {
            this.$api.get('/api/faker', {}).then(response => {
                this.coreOptions = [
                    {value: 1, label: 'Core'},
                    {value: 2, label: 'Not Core'}
                ]
            });
        },
        getIconicOptions() {
            this.$api.get('/api/faker', {}).then(response => {
                this.iconicOptions = [
                    {value: 1, label: 'Iconic'},
                    {value: 2, label: 'Not Iconic'}
                ]
            });
        },
    }
    
}
</script>